import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-23/task-02";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "Use headphones to listen to each sample and match it with a corresponding “virtual” speaker location it<br>represents. Binaural audio containing the complete mix is provided as an additional reference.",
  description: "Connect with lines.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [3, 0, 4],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/23/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/03/23/task/task-2-complete-mix.wav`,
                  text: "Complete mix",
                  shape: "round",
                  theme: "primary",
                  icon: "cis-volume-high",
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
